import { Col } from "react-flexbox-grid"
import React from "react"

export const _customAlignCol = (props: any) => <Col {...props} />
